import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { embeddedAdminPrefix, storeBasePath } from "@go-novus/admin-api";

import { boundShopDomain } from "#/shared/lib/bound-store";

/** 将 Shopify 原生菜单的导航交给当前后台路由，保留店铺和搜索参数。 */
export function useShopifyNavigation() {
  const router = useRouter();
  useEffect(() => {
    const shop = boundShopDomain();
    if (
      !shop ||
      !window.location.pathname.startsWith(`${embeddedAdminPrefix}/`)
    )
      return;
    const base = `${embeddedAdminPrefix}${storeBasePath(shop)}/`;
    const navigate = (event: Event) => {
      const href =
        event.target instanceof Element
          ? event.target.getAttribute("href")
          : null;
      if (!href || !URL.canParse(href, window.location.href)) return;
      const destination = new URL(href, window.location.href);
      if (
        destination.origin !== window.location.origin ||
        !destination.pathname.startsWith(base)
      )
        return;
      event.preventDefault();
      router.history.push(
        `${destination.pathname}${destination.search}${destination.hash}`,
      );
    };
    document.addEventListener("shopify:navigate", navigate);
    return () => {
      document.removeEventListener("shopify:navigate", navigate);
    };
  }, [router]);
}
